import React, {useContext, useEffect, useState, useCallback} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import AddNewEntityFilter from '../AddNewEntityFilter'
import _ from 'lodash'
import Cookies from 'js-cookie'

const FTextField = ({data, setData, onChange = (e, key, value) => {}}) => {
  let entityOptions = []
  const {groups, getGroups, entityObjects, loadEntityObjects, multipleListFormDirty} = useContext(
    ReservationConfigurationContext
  )
  const [addFilter, setAddFilter] = useState([])

  useEffect(() => {
    getGroups()
  }, [getGroups])

  const convertToArr = useCallback(() => {
    let newArr = []
    if (typeof data?.list_filters_attributes === 'object') {
      newArr = Object.keys(data?.list_filters_attributes).map((key, i) => {
        return data?.list_filters_attributes[key]
      })
    } else {
      newArr = data?.list_filters_attributes
    }
    return newArr
    // eslint-disable-next-line
  }, [data?.list_filters_attributes])

  useEffect(() => {
    if (data.description) {
      loadEntityObjects(data.description)
    }
  }, [data, loadEntityObjects])

  useEffect(() => {
    if (!_.isEmpty(data?.list_filters_attributes) && !multipleListFormDirty) {
      const Newdata = convertToArr()
      setAddFilter([...Newdata])
    }
    // eslint-disable-next-line
  }, [data?.list_filters_attributes])

  const handleAdd = () => {
    const values = [...addFilter]
    values.push({value: null, fieldType: null})
    setAddFilter(values)
  }

  const handleRemoveInput = (i, val = null, event) => {
    const id = event.target.closest('[id]').id
    document.getElementById(id).remove()
    const value = data.id
    Cookies.set('filters_removed_' + value, true)

    const values = [...addFilter]
    if (val.id) {
      values.splice(i, 1)
      onChange('fieldRemove', 'list_filters_attributes', '', '', i, val)
    } else {
      values.splice(i, 1)
      onChange('fieldRemove', 'list_filters_attributes', '', '', i)
    }
    // setAddFilter(values)
  }

  const setFieldType = (data, index) => {
    let _addFilter = [...addFilter]
    _addFilter[index].fieldType = data ? data : ''
    setAddFilter(_addFilter)
  }

  const handleChange = (e, value) => {
    setData({...data, list_filters_attributes: []})
    setAddFilter([])
    onChange(e, 'description')
  }

  return (
    <>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">List options</InputLabel>
        <Select
          labelId=""
          id=""
          label="List options"
          value={
            data.type === 'MultipleEntityListField' ? data.description || [] : data.description
          }
          onChange={(e, value) => handleChange(e, value)}
          style={{width: '200px'}}
        >
          {groups.groups?.map(opt => {
            return <MenuItem value={opt.id}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      <FormControl
        variant="outlined"
        className="ap-textfield"
        style={{minWidth: 200, marginTop: 16}}
      >
        <InputLabel id="">Limit list to</InputLabel>
        <Select
          labelId=""
          id=""
          label="Limit list to"
          value={data?.list_limit_attributes || []}
          onChange={(e, value) => onChange(e, 'list_limit_attributes')}
          style={{width: '200px'}}
          multiple
        >
          {entityObjects.data.objects?.map(opt => {
            return <MenuItem value={opt.id}>{`${opt.display_name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      {addFilter.length > 0 && (
        <AddNewEntityFilter
          addFilter={addFilter}
          groupId={data.description}
          handleRemoveInput={handleRemoveInput}
          onChange={onChange}
          fieldData={convertToArr()}
          setFieldType={setFieldType}
        />
      )}
      <div>
        <button
          type="button"
          style={{
            border: 'none',
            backgroundColor: 'transparent',
            color: '#336699',
            outline: 'none',
          }}
          onClick={() => handleAdd()}
        >
          Add new Filter
        </button>
      </div>
    </>
  )
}

export default FTextField
